import React, {useEffect, useState} from 'react';
import {get} from '../../../api/api';
import {UriProgressBar} from '../../../api/endpoints';
import StatusBar from '../../../components/status-bar';

export interface ProgessBarApiResponse {
  state: string;
  isSuccess: boolean;
  totalSteps: number;
  currentStep: number;
  errorCode: number;
  errorMessage: string;
}

type ReimbursementSubmissionStatusBarProps = {
  sessionId: string;
  ReimbursementFinishedSubmitting(values?: any): void;
  changedItem?: any;
  selectedItem?: any;
};

function ReimbursementSubmissionStatusBar(
  props: ReimbursementSubmissionStatusBarProps
) {
  const [progress, setprogress] = useState<ProgessBarApiResponse>();
  const [totalSteps, setTotalSteps] = useState();
  //set timer

  let timer: any;
  let mounted: boolean;

  useEffect(() => {
    mounted = true;
    updateProgress();
    return function cleanup() {
      mounted = false;
    };
  }, []);
  //only want a repolling to happen when isSuccess = false, errorCode===0
  useEffect(() => {
    mounted = true;
    if (
      (progress &&
        progress?.currentStep < progress?.totalSteps &&
        progress?.errorCode === 0) ||
      (progress?.totalSteps === 0 && progress?.errorCode === 0)
    ) {
      timer = setInterval(() => {
        updateProgress();
        clearInterval(timer);
      }, 5000);
    } else if (
      (progress?.errorCode === 0 &&
        progress?.totalSteps > 0 &&
        progress?.currentStep === progress?.totalSteps) ||
      progress?.errorCode === 1
    ) {
      props.ReimbursementFinishedSubmitting(progress);
      if(props.changedItem){
        props.selectedItem.estadoId = '101';
        props.changedItem(props.selectedItem);
      }
    }

    if(progress?.isSuccess === false && progress?.errorCode !== 0){
      props.ReimbursementFinishedSubmitting(
        progress,
      );
    }
    
    return function cleanup() {
      mounted = false;
    };
  }, [progress]);

  function updateProgress() {
    //call uriprogressbar
    getProgressBarInfo().then((res) => {
      if (mounted) {
        setprogress(res as ProgessBarApiResponse);
      }
    });

    //if final conditions met, stop timer
    async function getProgressBarInfo() {
      try {
        return await get(UriProgressBar(props.sessionId));
      } catch {
        return null;
      }
    }
  }

  return (
    <StatusBar
      currentSteps={progress?.currentStep}
      totalSteps={progress?.totalSteps}
    />
  );
}

export default ReimbursementSubmissionStatusBar;
